export default {
    EXIGE_REGISTRO_NA_APAC_DE_DADOS_COMPLEMENTARES: '022',
    EXIGE_DATA_DO_RESULTADO_DIAGNOSTICO_DE_NEOPLASIA: '055',
}